<template>
	<div class="main">
		<div class="container">
			<!-- 登录 -->
			<div class="login">
				<div>
					<img src="../assets/img/图片1.png" alt="" />
					<h3>自律平台</h3>
				</div>
				<div class="btn">
					<button v-if="!$store.state.token" @click="login()">会员登录</button>
					<button v-if="!$store.state.token" @click="register()">申请入会</button>
					<button v-if="$store.state.token" @click="exit()">退出</button>
					<button v-if="$store.state.token" @click="goMembership()">我的信息</button>
					<button><span @click="goDetail({ link: 'hyxx', name: '会员信息' })">协会会员信息</span></button>
					<!-- <button><span @click="goApply">我要展示</span></button> -->
				</div>
			</div>
			<!-- 轮播图 -->
			<div class="swiper mySwiper">
				<div class="swiper-wrapper">
					<div class="swiper-slide" v-for="(s, index) in swiperData" :key="index">
						<a @click="goArticle('article', s.typea, s.typeb, s.id)">
							<img :src="getImg(s.imgPath) ? getImg(s.imgPath) : require('../assets/img/a3b216cc69eefecde0d5a55378dc7538.jpeg')"
						/></a>
						<div class="box">
							<a @click="goArticle('article', s.typea, s.typeb, s.id)">{{ s.title }}</a>
						</div>
					</div>
				</div>
				<div class="swiper-button-next"></div>
				<div class="swiper-button-prev"></div>
				<div class="swiper-pagination"></div>
			</div>
			<!-- 导航栏 -->
			<ul class="nav">
				<li v-for="(n, index) in navList" :key="index" @mouseover="n.show = true" @mouseleave="n.show = false">
					<div @click="goDetail(n)">
						{{ n.name }}
						<div>
							<i class="iconfont" :class="n.icon" :style="{ fontSize: n.fontSize }"></i>
						</div>
					</div>
				</li>
			</ul>
		</div>
		<div class="container2">
			<ul>
				<li v-for="(c, index) in contentData" :key="index">
					<img :src="c.url" @click="goArticleList(c.link, c.typea, c.typeb, c.name)" />
				</li>
			</ul>
		</div>
		<div class="container4">
			<div class="container4-item">
				<div class="item-title">
					<div class="item-left">
						<span></span>
						<h3>提供服务</h3>
					</div>
					<div class="item-right">
						<div class="scrolling-container" :style="scrollingStyle" @mouseover="pauseScroll" @mouseleave="resumeScroll">
							<div v-for="(d, idx) in offerServerList" :key="idx" class="scroll-item">
								<div class="item-name" @click="navigateToUrl(d.url)">{{ d.companyName }}</div>
								<div class="item-status" :class="{ finished: d?.status == 3 }">{{ d.content }}</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="container4-item">
				<div class="item-title">
					<div class="item-left">
						<span></span>
						<h3>需求服务</h3>
					</div>
					<div class="item-right">
						<div class="scrolling-container" :style="scrollingStyle" @mouseover="pauseScroll" @mouseleave="resumeScroll">
							<div v-for="(d, idx) in demandServerList" :key="idx" class="scroll-item" @click="navigateToUrl()">
								<div class="item-name">{{ d.companyName }}</div>
								<div class="item-name">{{ d?.title }}</div>
								<div class="item-status" :class="{ finished: d?.status == 3 }">{{ d?.statusValue }}</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="container3">
			<div class="title">
				<div class="left">
					<span></span>
					<h3>会员服务</h3>
				</div>
			</div>
			<ul class="content">
				<li v-for="(s, idx) in service" :key="idx" @click="goArticleList(s.url, s.pcode, s.code, s.name)">
					<img :src="s.indexImg ? s.indexImg : require('../assets/img/nav.jpeg')" />
					<p :style="{ color: s.color }">{{ s.name }}</p>
					<div class="text" style="white-space: pre-line">{{ s.name }}</div>
				</li>
			</ul>
		</div>
		<div class="container3">
			<div class="title">
				<div class="left">
					<span></span>
					<h3>供需对接</h3>
				</div>
			</div>
			<ul class="content">
				<li v-for="c in contentData2" :key="c.id" @click="goArticleList(c.url, c.pcode, c.code, c.name)">
					<img :src="c.indexImg ? c.indexImg : require('../assets/img/nav.jpeg')" />
					<p :style="{ color: c.color }">{{ c.name }}</p>
					<div class="text" style="white-space: pre-line">{{ c.name }}</div>
				</li>
			</ul>
		</div>
		<div class="container3">
			<div class="title">
				<div class="left">
					<span></span>
					<h3>引领规范</h3>
				</div>
			</div>
			<ul class="content">
				<li v-for="(s, idx) in leadData" :key="idx" @click="goArticleList(s.url, s.pcode, s.code, s.name)">
					<img :src="s.indexImg ? s.indexImg : require('../assets/img/nav.jpeg')" />
					<p :style="{ color: s.color }">{{ s.name }}</p>
					<div class="text" style="white-space: pre-line">{{ s.name }}</div>
				</li>
			</ul>
		</div>
		<div class="container3">
			<div class="title">
				<div class="left">
					<span></span>
					<h3>协会工作</h3>
				</div>
				<!-- <div class="right">
                        <span>查看更多</span>
                        <i class="iconfont icon-shuangyoujiantou-"></i>
                    </div> -->
			</div>
			<ul class="content2">
				<li v-for="(c, index) in contentData3" :key="index" @click="goArticle('article', c.typea, c.typeb, c.id)">
					<div>
						<span></span>
						<p>{{ c.title }}</p>
					</div>
					<p>{{ c.date }}</p>
				</li>
			</ul>
		</div>
	</div>
</template>

<script>
import { articleListApi, NavApi, gxdjListApi, tgfwListApi } from '../axios/request';
import Swiper from 'swiper';
import { imgSApi, getCmsDicts } from '../axios/request';

export default {
	name: 'HomeContent',
	data() {
		return {
			color: ['#393939', '#da4ec5', '#dd8758', '#2f7787', '#236a3e', '#11ace4', '#1296db', '#234e9c'],
			swiper: '',
			pageParam: {
				pageNo: 1,
				pageSize: 20,
				param: {
					status: 2,
					swiperFlag: 1,
				},
			},

			scrollDuration: 15,
			animationPlayState: 'running',
			// 提供服务
			offerServerList: [],
			// 需求服务
			demandServerList: [],
			swiperData: [],
			navList: [
				{
					name: '协会介绍',
					icon: 'icon-jieshao',
					fontSize: '27px',
					show: false,
					link: 'xhjs',
					children: [],
				},
				{
					name: '协会章程',
					icon: 'icon-zhangcheng',
					fontSize: '23px',
					show: false,
					link: 'xhzc',
					children: [],
				},
				{
					name: '分支机构/代表机构',
					icon: 'icon-zuzhijigou',
					fontSize: '27px',
					show: false,
					link: 'fzjg',
					children: [],
				},
				{
					name: '秘书处',
					icon: 'icon-icon_xinyong_xianxing_jijin-',
					fontSize: '25px',
					show: false,
					link: 'msc',
					children: [],
				},
				{
					name: '服务清单',
					icon: 'icon-qingdan',
					fontSize: '23px',
					show: false,
					link: 'fwqd',
					children: [],
				},
				{
					name: '公示栏',
					icon: 'icon-gongshilan',
					fontSize: '23px',
					show: false,
					link: 'articleList',
					typea: 'WEB_INDEX',
					typeb: 'SY-GONGSHILAN',
					children: [],
				},
				{
					name: '协会会议',
					icon: 'icon-baogao-copy',
					fontSize: '27px',
					show: false,
					link: 'xhhy',
					children: [],
				},
			],
			contentData: [
				{
					url: require('../assets/img/1.png'),
					name: '党建联建',
					link: '',
				},
				{
					url: require('../assets/img/4.png'),
					name: '供需对接',
					// name: '品牌房企',
					link: '',
				},
				{
					url: require('../assets/img/3.png'),
					name: '自律规范',
					link: '',
				},
				{
					url: require('../assets/img/2.png'),
					name: '引领发展',
					link: '',
				},
				{
					url: require('../assets/img/5.png'),
					name: '会员服务',
					link: '',
				},
			],
			service: [],
			leadData: [],
			contentData2: [],
			contentData3: [
				'[诚信承诺] 上海市房地产行业协会诚信承诺企业公告',
				'[会员交流] 第十届“广厦奖”获奖项目赏析——闵都雅苑',
				'[会员交流] 第十届“广厦奖”获奖项目赏析——南翔秀城•孚锦雅苑',
				'[协会工作] 《全面落实建设单位安全首要责任》实施指南培训通知',
			],
			pageParam2: {
				pageNo: 1,
				pageSize: 10,
				param: {
					status: 2,
					indexFlag: 1,
				},
			},
			nav: [],
		};
	},
	watch: {
		'$store.state.nav': {
			handler(newValue) {
				this.nav = newValue;
				for (const i in this.contentData) {
					let item = this.contentData[i];
					for (const j in newValue) {
						let item2 = newValue[j];
						if (item.name == item2.name) {
							item.vipFlag = item2.vipFlag;
							item.typea = item2.code;
							item.link = item2.children[0].url;
							item.typeb = item2.children[0].code;
						}
					}
				}
			},
			deep: true,
			immediate: true,
		},
	},
	mounted() {
		this.getSwiperData();
		this.getServiceData();
		this.getLeadData();
		this.getContentData2Data();
		this.getContentData3Data();
		this.getgxdjData();
		this.gettgfwData();
	},
	computed: {
		scrollingStyle() {
			return {
				animationDuration: `${this.scrollDuration}s`,
				animationPlayState: this.animationPlayState,
			};
		},
	},
	methods: {
		// 提供服务
		async getgxdjData() {
			const res = await tgfwListApi(this.pageParam);
			if (res != null && res.code == 200) {
				this.offerServerList = res.data;
			}
		},
		// 需求服务
		async gettgfwData() {
			const res = await gxdjListApi(this.pageParam);
			if (res != null && res.code == 200) {
				console.log('需求服务', res.data);
				this.demandServerList = res.data;
			}
		},
		// 鼠标悬停时暂停动画
		pauseScroll() {
			this.animationPlayState = 'paused';
		},
		// 鼠标移开时恢复动画
		resumeScroll() {
			this.animationPlayState = 'running';
		},
		// 点击公司名时跳转
		navigateToUrl(url) {
			if (url) {
				window.open(url);
			} else {
				window.location.href = process.env.VUE_APP_BASE_URL_API + '/nkyxf/nav/gxdj-t/index-person';
				// const url = process.env.VUE_APP_BASE_URL_API + '/nkyxf/nav/gxdj-t/index-person';
				// window.open(url);
			}
		},
		getImg(id) {
			if (!id) return null;
			const response = imgSApi(id);
			return response;
		},
		// 获取轮播图数据
		async getSwiperData() {
			const res = await articleListApi(this.pageParam);
			// console.log('轮播图信息', res);
			if (res != null && res.code == 200) {
				this.swiperData = res.data.results;
				// console.log('this.swiperData', this.swiperData)
			}
			// 生成轮播图
			this.$nextTick(() => {
				this.swiper = new Swiper('.mySwiper', {
					observer: true,
					observeParents: true,
					loop: true,
					spaceBetween: 30,
					centeredSlides: true,
					autoplay: {
						delay: 5000,
						disableOnInteraction: false,
					},
					direction: 'horizontal',
					pagination: {
						el: '.swiper-pagination',
						type: 'fraction',
						clickable: true,
					},
					navigation: {
						nextEl: '.swiper-button-next',
						prevEl: '.swiper-button-prev',
					},
				});
			});
		},
		// 获取会员专区数据
		async getServiceData() {
			const res = await NavApi({ level: 2, vipFlag: 1 });
			this.service = [
				{ id: 1, color: '#000', name: '服务清单', pcode: 'fwqd', code: '' },
				{ id: 2, color: '#000', name: '会员展示', pcode: 'hyzs', code: '' },
				{ id: 3, color: '#000', name: '企业沙龙', pcode: 'WEB_HYFW', code: 'WEB_HYFW_QYSL' },
				{ id: 4, color: '#000', name: '调研座谈', pcode: 'WEB_HYFW', code: 'WEB_HYFW_DYBG' },
				{ id: 5, color: '#000', name: '会员诉求', pcode: 'WEB_HYFW', code: 'WEB_HYFW_HYHS' },
				{ id: 6, color: '#000', name: '定期会议', pcode: 'WEB_HYFW', code: 'WEB_HYFW_DQHY' },
				{ id: 7, color: '#000', name: '培训服务', pcode: 'WEB_HYFW', code: 'WEB_HYFW_PXFW' },
				{ id: 8, color: '#000', name: '会刊', pcode: 'WEB_HYFW', code: 'WEB_HYFW_HK' },
				{ id: 9, color: '#000', name: '简讯', pcode: 'WEB_HYFW', code: 'WEB_HYFW_JX' },
			];
			if (res != null && res.code == 200) {
				// this.service = res.data
				// console.log('会员专区信息', res.data)
				this.service.forEach(item => {
					if (item.indexImg) {
						item.indexImg = process.env.VUE_APP_BASE_URL_API + item.indexImg;
					}
					let randomNum = Math.floor(Math.random() * 8);
					item.color = this.color[randomNum];
				});
				// console.log('this.service', this.service)
			}
		},
		// 获取引领规范数据 （自律规范和引领发展合并）
		async getLeadData() {
			try {
				const [res, res1] = await Promise.all([NavApi({ level: 2, pcode: 'WEB_ZLGF' }), NavApi({ level: 2, pcode: 'WEB_YLFZ' })]);
				let base = [];
				let additionalData = [];
				if (res != null && res.code == 200) {
					base = res.data;
				}
				if (res1 != null && res1.code == 200) {
					additionalData = res1.data;
				}
				this.leadData = [...base, ...additionalData]?.map(item => {
					if (item.indexImg && !item.indexImg.startsWith(process.env.VUE_APP_BASE_URL_API)) {
						item.indexImg = process.env.VUE_APP_BASE_URL_API + item.indexImg;
					}
					let randomNum = Math.floor(Math.random() * 8);
					item.color = this.color[randomNum];
					return item;
				});
				// console.log('获取引领规范数据', this.leadData)
			} catch (error) {
				console.error(error);
			}
		},
		// 获取供需对接数据
		async getContentData2Data() {
			const res = await NavApi({ level: 2, pcode: 'WEB_GXDJ' });
			// console.log('供需对接信息', res);
			if (res != null && res.code == 200) {
				this.contentData2 = res.data;
				this.contentData2.forEach(item => {
					if (item.indexImg) {
						item.indexImg = process.env.VUE_APP_BASE_URL_API + item.indexImg;
					}
					let randomNum = Math.floor(Math.random() * 8);
					item.color = this.color[randomNum];
				});
			}
		},
		// 获取协会工作数据
		async getContentData3Data() {
			const res = await articleListApi(this.pageParam2);
			// console.log('协会工作信息', res);
			if (res != null && res.code == 200) {
				this.contentData3 = res.data.results;
				this.contentData3.forEach(item => {
					item.date = item.releaseTime.split(' ')[0];
				});
			}
		},
		// 跳转文章详情页
		goArticle(link, typea, typeb, id) {
			this.$router.push({ name: link, query: { typea: typea, typeb: typeb, id: id } });
		},
		// 跳转文章列表页面
		goArticleList(url, pcode, code, name) {
			const token = this.$store.state.token;
			if ((pcode === 'WEB_HYFW' && code !== 'WEB_HYFW_PXFW') || (pcode === 'WEB_GXDJ' && code === 'WEB_GXDJ-czgy') || (pcode === 'WEB_GXDJ' && code === 'WEB_GXDJ_SQ')) {
				if (!token) {
					this.login();
					return;
				}
			}
			if (url && url.startsWith('http')) {
				window.open(url);
				return;
			}
			if (!pcode && !code) return;
			// 路由处理
			const navigateTo = (name, query) => {
				this.$router.push({ name, query });
			};
			switch (pcode) {
				case 'fwqd':
					navigateTo('fwqd', { title: name }); //服务清单
					break;
				case 'hyzs':
					navigateTo('memberContent', { title: name }); //会员展示
					break;
				case 'WEB_GXDJ':
					if ((code === 'WEB_GXDJ_GJDJCY' || code === 'WEB_GXDJ-czgy') && name === '供需对接') {
						navigateTo('brandContent', { typea: 'WEB_INDEX', typeb: 'SY-PINGPAIFANGQI', title: '品牌房企' });
					} else if (code === 'WEB_GXDJ-jydb') {
						//房地产交易代办服务全流程
						// var fdjyUrl = '';
						// if (process.env.NODE_ENV === 'development') {
						// 	fdjyUrl = 'http://localhost:8080/#/main/index'; // 本机地址（开发环境）
						// } else if (process.env.NODE_ENV === 'production') {
						// 	fdjyUrl = 'http://47.116.163.170:8081/#/main/index'; // 正式环境地址（生产环境）
						// }
						// window.open(fdjyUrl);
						// this.$router.push({ name: 'index' });
						// const route = process.env.VUE_APP_NAME + '/main/index';
						// const baseUrl = window.location.origin;
						// const fullUrl = `${baseUrl}/${route}`;
						const fullUrl = this.$router.resolve({ name: 'index' }).href;
						window.open(fullUrl, '_blank');
					} else if (code === 'WEB_GXDJ-czgy' && name === '长租公寓专项服务') {
						const openUrl = 'http://www.dataln.com/sreta/#/'; //长租公寓
						window.open(openUrl);
					} else if (code === 'WEB_GXDJ_SQ') {
						//供需对接申请
						const title = '供需对接申请';
						const url = `${process.env.VUE_APP_BASE_URL_API}/nkyxf/nav/gxdj-t/form?title=${title}&token=${token}`;
						window.location.href = url;
					} else if (code == 'WEB_GXDJ_XYPX') {
						//f房地产专修学院培训
						window.open('http://www.fdcxy.org/');
					} else {
						navigateTo('articleList', { typea: pcode, typeb: code });
					}
					break;
				default:
					navigateTo('articleList', { typea: pcode, typeb: code });
					break;
			}
		},

		// 获得二级菜单数据
		async getNavListItem(name) {
			const res = await NavApi({ name: name });
			// console.log('菜单', res);
			if (res != null && res.code == 200) {
				this.$router.push({
					name: 'articleList',
					query: { typea: res.data[0].pcode, typeb: res.data[0].code },
				});
			}
		},
		goDetail(item) {
			if (item.link == 'articleList') {
				this.getNavListItem(item.name);
			} else if (item.link == 'xhhy') {
				this.$router.push({
					name: 'articleList',
					query: { typea: 'WEB_HYFW', typeb: 'WEB_HYFW_DQHY' },
				});
			} else {
				this.$router.push({ name: item.link, query: { title: item.name } });
			}
		},
		// 跳出登录弹窗
		login() {
			this.$store.commit('getLogin', true);
		},
		// 退出登录
		exit() {
			this.$store.state.token = '';
			localStorage.removeItem('token');
		},
		// 跳转会籍管理
		async goMembership() {
			const res = await getCmsDicts({});
			if (res != null && res.code == 200) {
				for (const [key, value] of Object.entries(res.data)) {
					localStorage.setItem(key, JSON.stringify(value));
				}
				window.location.href = process.env.VUE_APP_BASE_URL_API + '/nkyxf/nav/index/index?myinfo=1';
				// const url = process.env.VUE_APP_BASE_URL_API + '/nkyxf/nav/index/index?myinfo=1';
				// window.open(url);
			}
		},
		// 跳出注册弹窗
		async register() {
			const res = await getCmsDicts({});
			if (res != null && res.code == 200) {
				for (const [key, value] of Object.entries(res.data)) {
					localStorage.setItem(key, JSON.stringify(value));
				}
				this.$store.commit('getRegister', true);
			}
		},
		goApply() {
			window.location.href = process.env.VUE_APP_BASE_URL_API + '/nkyxf/nav/sm-member-show-info-t/index-person';
		},
	},
};
</script>

<style scoped>
.main {
	width: var(--main--width);
	margin: 0 auto;
}

.container {
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin: 1.25rem 0;
	width: 100%;
	height: 330px;
}

.login {
	flex: 1;
	display: flex;
	flex-direction: column;
	flex-wrap: wrap;
	justify-content: space-around;
	align-items: center;
	height: 100%;
	box-shadow: 0 8px 24px rgba(149, 157, 165, 0.2);
	box-shadow: 0px 8px 24px rgba(149, 157, 165, 0.2);
	box-shadow: 0px 7px 29px 0px rgba(100, 100, 111, 0.2);
}

.login h3 {
	margin-top: 15px;
	font-weight: 500;
	color: var(--text-color2);
}

.login .btn {
	display: flex;
	flex-direction: column;
	justify-content: space-around;
	align-items: center;
	width: 100%;
}

.login button {
	margin-top: 12px;
	width: 80%;
	height: 38px;
	border: 1px solid var(--bg-color);
	border-radius: 5px;
	color: var(--text-color);
	background-color: #fff;
	font-size: 0.875rem;
	cursor: pointer;
	-webkit-transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
	-moz-transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
	-ms-transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
	-o-transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
	transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}

.login button:first-child {
	margin-top: 0;
}

.btn a {
	display: contents;
}

.btn button:hover {
	background-color: var(--bg-color);
	color: var(--text-light-color);
}

.btn > button:first-of-type {
	color: #fff;
	background-color: var(--bg-color);
}

.btn > button:first-of-type:hover {
	background-color: var(--bg-color-8);
	border: 1px solid var(--bg-color-8);
	color: var(--text-light-color);
}

.mySwiper {
	position: relative;
	margin: 0 0.625rem;
	flex: 2;
	height: 100%;
	overflow: hidden;
	transition: all 0.5s;
}

.swiper-slide {
	text-align: center;
	font-size: 1.125rem;
	background: #fff;
	display: flex;
	justify-content: center;
	align-items: center;
}

.swiper-slide > a {
	display: inline-block;
	width: 100%;
	height: 100%;
}

.swiper-slide img {
	width: 100%;
	height: 100%;
	object-fit: fill;
	cursor: pointer;
}

.swiper-slide .box {
	position: absolute;
	bottom: 0;
	padding-bottom: 20px;
	width: 100%;
	background-color: rgba(0, 0, 0, 0.5);
	color: #fff;
	text-align: left;
}

.swiper-slide .box a {
	display: inline-block;
	margin: 10px 20px;
	cursor: pointer;
	font-size: 15px;
	line-height: 22px;
}

.swiper-slide .box a:hover {
	color: var(--text-color-light);
}

.swiper-button-prev,
.swiper-button-next {
	opacity: 0;
	color: var(--bg-color);
}

.swiper:hover .swiper-button-prev,
.swiper:hover .swiper-button-next {
	opacity: 1;
}

.swiper-pagination-fraction {
	bottom: 10px;
}

.swiper-pagination {
	padding-right: 10px;
	text-align: right;
	color: #888;
	font-size: 13px;
}

.nav {
	position: relative;
	display: flex;
	flex-direction: column;
	flex: 1;
	height: 100%;
}

.nav > li {
	flex: 1;
	display: flex;
	align-items: center;
	margin-bottom: 4px;
	width: 100%;
	background-color: #f2f2f2;
	cursor: pointer;
}
.nav > li > div {
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding-left: 40px;
	padding-right: 35px;
	width: 100%;
	height: 100%;
	color: var(--text-color2);
	font-size: 0.875rem;
	font-weight: 600;
}

.nav > li:last-child {
	margin-bottom: 0;
}

.nav > li:hover {
	color: #fff;
	background-color: var(--bg-color);
	border-left: 1px solid var(--bg-color);
}

.nav > li:hover > div {
	color: #fff;
}

.nav > li:hover .iconfont {
	color: #fff;
}

.nav li div div {
	display: flex;
	justify-content: center;
	align-items: center;
	width: 40px;
	height: 100%;
	text-align: center;
}

.nav .iconfont {
	color: var(--text-color);
}

.nav .n {
	position: absolute;
	top: 0;
	left: -100%;
	width: 100%;
	height: 100%;
	color: var(--text-color2);
	border: 1px solid #e0e0e0;
	background: rgba(242, 242, 242, 0.9);
	-webkit-box-shadow: 0 8px 16px rgba(0, 0, 0, 0.18);
	box-shadow: 0 8px 16px rgba(0, 0, 0, 0.18);
	z-index: 1;
}

.nav .n li {
	display: flex;
	justify-content: space-between;
	align-items: center;
	width: 100%;
	padding: 12px 20px;
	font-size: 0.875rem;
}

.nav .n li:hover {
	color: var(--text-color);
	text-decoration: underline;
}

.container2 {
	width: 100%;
}

.container2 ul {
	display: flex;
	flex-wrap: wrap;
	justify-content: space-between;
	align-items: center;
	width: 100%;
}

.container2 li {
	flex: 1;
	height: 130px;
	margin-top: 12px;
	margin-right: 12px;
	overflow: hidden;
	cursor: pointer;
}

.container2 li:first-child {
	flex: none;
	width: 100%;
	height: 100px;
	overflow: hidden;
}

.container2 li:last-child {
	margin-right: 0;
}

.c2-ul li {
	margin-top: 0;
}

.c2-ul li:first-child {
	flex: 2.03;
}

.container2 img {
	width: 100%;
	height: 100%;
	-webkit-transition: all 0.5s;
	-moz-transition: all 0.5s;
	-ms-transition: all 0.5s;
	-o-transition: all 0.5s;
	transition: all 0.5s;
}

.container2 li:hover img {
	-webkit-transform: scale(1.05);
	-moz-transform: scale(1.05);
	-ms-transform: scale(1.05);
	-o-transform: scale(1.05);
	transform: scale(1.05);
}

.container3 {
	margin: 20px auto;
	width: 100%;
}

.title {
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 15px 0;
	width: 100%;
	border-bottom: 1px solid #cacccc;
	color: var(--text-color2);
}

.title .left {
	display: flex;
	align-items: center;
	width: 70%;
}
/* 滚动样式开始 */

.container4 {
	margin: 20px auto;
	width: 100%;
	display: flex;
	justify-content: space-between;
	align-items: center;
}
.container4 .container4-item {
	width: 50%;
	display: flex;
	justify-content: space-between;
	align-items: center;
}
.container4 .container4-item .item-title {
	width: 100%;
	display: flex;
	justify-content: flex-start;
	align-items: center;
	padding: 15px 0;
	border-bottom: 1px solid #cacccc;
	color: var(--text-color2);
}
.item-title .item-left {
	width: 20%;
	display: flex;
	align-items: center;
	overflow: hidden;
}
.item-title .item-left span {
	margin-right: 10px;
	width: 5px;
	height: 26px;
	background-color: var(--bg-color);
}
.item-title .item-right {
	width: 78%;
	display: flex;
	align-items: center;
	overflow: hidden;
	position: relative;
}
.scrolling-container {
	display: flex;
	flex-direction: row;
	animation: scrollLeftToRight linear infinite;
	width: max-content;
}
.scroll-item {
	display: flex;
	align-items: center;
	padding-right: 30px;
}

.scroll-item .item-name {
	font-size: 18px;
	cursor: pointer;
	padding-right: 10px;
	white-space: nowrap;
	display: inline-block;
}

.scroll-item .item-status {
	font-size: 18px;

	white-space: nowrap;
	display: inline-block;
}
.item-status.finished {
	color: var(--bg-color);
}

@keyframes scrollLeftToRight {
	0% {
		transform: translateX(15%);
	}
	100% {
		transform: translateX(-100%);
	}
}

/* 滚动样式 */
.title span {
	margin-right: 10px;
	width: 5px;
	height: 26px;
	background-color: var(--bg-color);
}

.title .right {
	display: flex;
	align-items: center;
	color: var(--text-color2);
	cursor: pointer;
}

.title .right:hover {
	color: var(--text-color);
}

.title .right span {
	margin-right: 2px;
	width: auto;
	height: auto;
	font-size: 14px;
	background-color: transparent;
}

.title .right .iconfont {
	font-size: 14px;
}

.content {
	display: flex;
	flex-wrap: wrap;
	width: 100%;
}

.content li {
	position: relative;
	width: 32.5%;
	height: 150px;
	margin-top: 12px;
	margin-right: 1.2%;
	overflow: hidden;
	cursor: pointer;
	-webkit-transition: all 0.5s;
	-moz-transition: all 0.5s;
	-ms-transition: all 0.5s;
	-o-transition: all 0.5s;
	transition: all 0.5s;
	overflow: hidden;
}

.content li:nth-child(3n) {
	margin-right: 0;
}

.content li img {
	width: 100%;
	height: 100%;
	-webkit-transition: all 0.5s;
	-moz-transition: all 0.5s;
	-ms-transition: all 0.5s;
	-o-transition: all 0.5s;
	transition: all 0.5s;
	filter: blur(1px);
}

.content li p {
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	padding: 20px 0;
	width: 100%;
	text-align: center;
	font-size: 28px;
	font-family: KaiTi;
	font-weight: 600;
	background: rgba(255, 255, 255, 0.75);
	white-space: pre-wrap;
	word-wrap: break-word;
	word-break: break-all;
	letter-spacing: 2px;
	z-index: 2;
}

.content li .text {
	width: 100%;
	height: auto;
	position: absolute;
	left: 0;
	color: #fff;
	text-align: left;
	-webkit-transition: all 0.5s;
	-moz-transition: all 0.5s;
	-ms-transition: all 0.5s;
	-o-transition: all 0.5s;
	transition: all 0.5s;
	bottom: -100%;
	padding: 15px;
	font-size: 14px;
	z-index: 3;
}

.content li:hover::after {
	content: '';
	display: block;
	position: absolute;
	top: 0;
	width: 100%;
	height: 100%;
	background-color: rgba(0, 0, 0, 0.2);
	z-index: 2;
}

.content li:hover img {
	-webkit-transform: scale(1.05);
	-moz-transform: scale(1.05);
	-ms-transform: scale(1.05);
	-o-transform: scale(1.05);
	transform: scale(1.05);
}

.content li:hover .text {
	bottom: 0;
}

.content2 {
	width: 100%;
	margin-top: 12px;
	margin-bottom: 50px;
}

.content2 li {
	display: flex;
	justify-content: space-between;
	align-items: center;
	width: 100%;
	padding: 13px;
	border-bottom: 1px dashed #ccc;
	font-size: 16px;
	color: #666;
	cursor: pointer;
}

.content2 li div {
	display: flex;
	align-items: center;
}

.content2 li div span {
	margin-right: 15px;
	width: 5px;
	height: 5px;
	background-color: var(--bg-color);
}

.content2 li div p {
	width: 98%;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}

.content2 li:hover p {
	color: var(--text-color);
}

.content2 li:hover div p {
	text-decoration: underline;
}
</style>
<style>
.my-bullet {
	display: inline-block;
	width: 0.625rem;
	height: 0.625rem;
	border-radius: 0.3125rem;
	background-color: #fff;
	opacity: 0.7;
	margin: 0 4px;
	cursor: pointer;
}

.my-bullet-active {
	width: 1.875rem;
	height: 0.625rem;
	border-radius: 0.3125rem;
	background-color: var(--bg-color);
	opacity: 1;
}
</style>
